module.exports = __webpack_public_path__ + "static/media/LOGO_SIMA_png-02 (1).2125c33a.png";